module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Subtitle/images/background.268246f2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Subtitle/images/background.png
// module id = 3238
// module chunks = 11